import { useDebugValue, useMemo } from "react"
import { dataCompanyGlobeMap, dataCompanyMap, environment, inLocalDevelopment } from "modules/environments"
import { useUser } from "modules/users"
import { useSales } from "sites/Sales"

export const useSites = () => {
  const user = useUser()
  const sales = useSales()

  const sites = useMemo(() => {
    const menuFilter = (entry) => {
      if (!entry.id && inLocalDevelopment) {
        return true
      }
      // if (!entry.id && ['develop', 'regression'].includes(environment)) {
      //   return false;
      // }
      return user ? user.menus && user.menus.find((item) => entry.id === item.menu_id) : false
    }

    return [sales].map((site) => ({
      ...site,
      image: `/apps/${site.name === "dashboard" ? "service" : site.name}/${environment === "production" ? "logo" : environment}.png`,
      manifest: `/apps/${site.name}/${environment === "production" ? "manifest" : environment}.json`,
      entries:
        site.name === "sales"
          ? site.entries
          : site.entries
              .map((entry) =>
                Object.assign({}, entry, {
                  entries: entry.entries ? entry.entries.filter(menuFilter) : undefined,
                }),
              )
              .filter((entry) =>
                entry.entries ? entry.entries.length && entry.entries.every(menuFilter) : menuFilter(entry),
              ),
    }))
  }, [user, sales])

  return sites
}

export const useSite = () => {
  const sites = useSites()

  const site = useMemo(
    () =>
      sites.find(({ name, host }) => {
        const hostName = window.location.host.split(".")[0]
        return process.env.REACT_APP_NAME
          ? process.env.REACT_APP_NAME === name
          : hostName.includes(name) || hostName.includes(host)
      }) || sites[0],
    [sites],
  )

  useDebugValue(site.name)

  return site
}

export const useGlobe = () => {
  const hostName = window.location.host.split(".")
  const isGlobe = hostName.includes("globe") || hostName.includes("ph")

  return { isGlobe }
}

export const useDataCompany = () => {
  const { isGlobe } = useGlobe()
  const dataCompany = dataCompanyMap[environment]
  const dataCompanyGlobe = dataCompanyGlobeMap[environment]

  return isGlobe ? dataCompanyGlobe : dataCompany
}
